import styles from "./index.css";

const PlaceholderImage = () => (
  <img className={styles.image} alt="" data-auto-id="productTileEmptyImage" />
);

export default PlaceholderImage;
